module.exports = __webpack_public_path__ + "img/bg-mytrusted.ddad18e9.png";